export default "__VITE_ASSET__cHH3VqRO__"